import React, { useState, useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { isMobile, isMobileOnly, isTablet } from 'mobile-device-detect'

import history from 'utils/history'
import styled from 'styled-components'
import { MEDIA_BUCKET, ROLES, supportedPlayIds } from 'config'

import Logo from 'assets/images/GoTackle-Logo.svg'
import CrossIcon from 'assets/svgs/cross.svg'
import Tabs from 'components/Common/Tabs'
import { TabHeading } from 'components/Owner/Plays/card-style'
import {
  copy,
  getActiveStepAndNavigation,
  getActiveStepAndNavigationLink,
  getLink,
  navigateTo,
  scrollToTop,
} from 'utils/helper'
import { PlayViewContainer } from 'pages/Owner/container'

import { ampli } from 'ampli'
import { AppFC } from 'types'
import { isEmpty } from 'lodash'

const Plays = ({
  userSummary,
  play,
  playStage,
  currentUser,
  getPlayAction,
  isPlayLoading,
  isPlayCompleted,
  resetPlayAction,
  assessmentResponse,
  updatePlayStageAction,
  saveAssessmentResponseAction,
  getPlayAssessmentResponseAction,
  getPlayResponseAction,
  isUpdateStage,
  isPlayInReview,
  disableButton,
}) => {
  const { stepName, id } = useParams()
  const [activeStep, setActiveStep] = useState('')
  const [setupActiveStepIndex, setSetUpActiveStepIndex] = useState(0)
  const [tabIndex, setTabIndex] = useState(0)
  const [playData, setPlayData]: any = useState({}) //play object
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [playCurrentStage, setPlayCurrentStage] = useState({})
  const [currentStage, setCurrentStage] = useState([])
  useEffect(() => {
    if (supportedPlayIds.includes(id)) {
      getPlayResponseAction({ playId: id })
    } else {
      getPlayAction({
        playId: id,
        userId: currentUser?.id,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, getPlayAction])

  useEffect(() => {
    setPlayData(play)
  }, [play, setPlayData])

  useEffect(() => {
    setCurrentStage(playStage)
  }, [playStage])

  useEffect(() => {
    if (!isUpdateStage) {
      if (playData.playTabs && playStage && playStage.length > 0) {
        let { activeTabIndex, activeStep, link, activeStepIndex } = getActiveStepAndNavigation(
          id,
          playStage,
          playData,
          isPlayInReview,
          disableButton
        )

        setActiveStep(activeStep)
        setSetUpActiveStepIndex(activeStepIndex)
        setTabIndex(activeTabIndex)
        setCurrentStage(playStage)

        history.push(link)
      } else {
        let { activeStep, link, activeStepIndex } = getActiveStepAndNavigationLink({
          playStage,
          stepName,
          id,
        })

        setActiveStep(activeStep)
        history.push(link)
        setSetUpActiveStepIndex(activeStepIndex)
        setPlayCurrentStage(playStage)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playData, playStage])

  useEffect(() => {
    if (isPlayCompleted && !isEmpty(playData)) {
      ampli.completedPlayViewedByBo({
        userName: userSummary.userName,
        businessName: userSummary.businessName,
        industry: userSummary.industry,
        playName: supportedPlayIds.includes(id) ? playData.name : playData.description,
        level: playData.title ? playData.title.split('Level')[1].trim() : '',
        currentTab: playData?.playTabs[tabIndex]?.tabName,
        category: playData.meta.category,
      })
    }
    // eslint-disable-next-line
  }, [tabIndex])

  useEffect(() => {
    return resetPlayAction()
    // eslint-disable-next-line
  }, [])

  const onChangeTab = (data) => {
    const index = playData.playTabs.findIndex(
      (tab) => tab.tabName.toLowerCase() === data.toLowerCase()
    )
    if (
      index === 0 ||
      playStage[index - 1].steps[playStage[index - 1].steps.length - 1].isCompleted
    ) {
      let activeStep = playData.playTabs[index].tabName.toLowerCase()
      let link = getLink(id, playData.playTabs[index].tabName.toLowerCase())

      setTabIndex(index)
      setActiveStep(activeStep)
      setSetUpActiveStepIndex(0)

      history.push(link)

      setCurrentStage(playStage)
    }
  }

  // const changeTabHandler = (step) => {
  //   let tempPlayStage = { ...playStage }

  //   if (step === PLAY_STEPS.GUIDE) {
  //     tempPlayStage.guide.isCompleted = false
  //   } else if (step === PLAY_STEPS.SETUP) {
  //     tempPlayStage.guide.isCompleted = true
  //     tempPlayStage.setUp.isCompleted = false
  //   } else if (step === PLAY_STEPS.USE) {
  //     tempPlayStage.guide.isCompleted = true
  //     tempPlayStage.setUp.isCompleted = true
  //     tempPlayStage.use.isCompleted = false
  //   }

  //   let { activeStep, link, activeStepIndex } = getActiveStepAndNavigationLink({
  //     playStage: tempPlayStage,
  //     stepName,
  //     id,
  //     tenantId,
  //   })

  //   setActiveStep(activeStep)
  //   setSetUpActiveStepIndex(activeStepIndex)
  //   history.push(link)

  //   setPlayCurrentStage(playStage)
  // }

  const changeSetUpStepHandler = (stepId) => {
    let tempPlayStage
    let index

    if (supportedPlayIds.includes(id)) {
      index = playData.playTabs[1].tabData.steps.findIndex(
        (step) => step.id.toLowerCase() === stepId.toLowerCase()
      )

      tempPlayStage = copy(playStage)
      if (tempPlayStage[tabIndex].steps[index !== 0 ? index - 1 : index].isCompleted) {
        setSetUpActiveStepIndex(index)
      }
    } else {
      if (playData.playTabs) {
        index = playData.playTabs[1].tabData.steps.findIndex(
          (step) => step.id.toLowerCase() === stepId.toLowerCase()
        )
      }
      if (playData.playTabs) {
        tempPlayStage = copy(playStage)
      } else {
        tempPlayStage = { ...playStage }
      }
      let activeStepIndex = 0

      if (playData.playTabs) {
        tempPlayStage[tabIndex].steps[setupActiveStepIndex].isCompleted = true
      } else {
        tempPlayStage?.setUp?.steps.forEach((step, index) => {
          if (step.id.trim() === stepId) {
            if (!playStage.isCompleted) {
              step.isCompleted = false
            }
            activeStepIndex = index
          }
        })
      }
      if (playData.playTabs) {
        setSetUpActiveStepIndex(index)
      } else {
        setSetUpActiveStepIndex(activeStepIndex)
      }
      setPlayCurrentStage(tempPlayStage)
      setCurrentStage(playStage)
    }
  }

  return (
    <div
      id="plays-container"
      className={`${isMobileOnly ? 'w-full' : 'w-full mb-4 px-6 lg:px-12'}`}
    >
      <div id="plays-heading-wrapper">
        {isMobile || isTablet ? (
          <div className="lg:ml-10 lg:mr-10 lg:mt-1">
            {playData?.title && (
              <>
                {isMobile && isTablet && <PlaysTabletHeading playData={playData} />}

                {isMobile && !isTablet && <PlaysMobileTabHeading playData={playData} />}
              </>
            )}
          </div>
        ) : (
          <PlaysWebHeading playData={playData} />
        )}
      </div>
      {playData?.playTabs ? (
        <>
          <Tabs
            id="play-tabs"
            activeStep={stepName}
            steps={playData.playTabs.map((item) => ({
              name: item?.tabName?.toLowerCase() || '',
              title: item.tabName,
            }))}
            updateTabHandler={onChangeTab}
          >
            <div id="banner-image-wrapper" className="imgIcon text-center flex justify-center">
              <BannerImage src={playData?.meta?.banner || ''} />
            </div>
          </Tabs>
          <PlayViewContainer
            activeTab={activeStep}
            assessmentResponse={assessmentResponse}
            changeSetUpStepHandler={changeSetUpStepHandler}
            changeTabHandler={onChangeTab}
            getPlayAction={getPlayAction}
            getPlayAssessmentResponseAction={getPlayAssessmentResponseAction}
            id={id}
            isPlayLoading={isPlayLoading}
            meta={playData.meta}
            playData={playData}
            playStage={currentStage}
            saveAssessmentResponseAction={saveAssessmentResponseAction}
            setupActiveStepIndex={setupActiveStepIndex}
            tab={playData.playTabs[tabIndex]}
            tabIndex={tabIndex}
            updatePlayStageAction={updatePlayStageAction}
            userId={currentUser?.id}
          />
        </>
      ) : // <p>This play is being updated - please come back later!</p>
      null}
    </div>
  )
}

const BannerImage: AppFC<{ src: string | undefined }> = ({ src }) => {
  const bannerImageUrl = useMemo(() => {
    return src ? `${MEDIA_BUCKET}/${src}` : ''
  }, [src])

  return bannerImageUrl ? (
    <img src={bannerImageUrl} alt="PlayIcon" />
  ) : (
    <img src={Logo} alt="GoTackle icon" className="object-contain h-[90px] w-[90px]" />
  )
}

const PlaysTabletHeading = ({ playData }) => (
  <>
    {/* hide on landscape view */}
    <LandscapeViewWrapper>
      <TabHeading className="">
        <div className="flex flex-col pl-4">
          <div className="text-xs"> {playData?.title} - PLAY</div>
          <div>
            <div className="text-base">
              {supportedPlayIds.includes(playData.id) ? playData.name : playData?.description}
            </div>
          </div>
        </div>
        <img
          src={CrossIcon}
          alt="cross-icon"
          className="lg:invisible xs:mr-10"
          onClick={() => navigateTo(ROLES.BUSINESS_OWNER, 'dashboard')}
        />
      </TabHeading>
    </LandscapeViewWrapper>

    {/* hide on portrail view */}
    <PortraitViewWrapper>
      <div>
        <div className="flex flex-col">
          <div>
            {playData?.title} &gt; PLAY &gt; <strong> {playData?.description}</strong>
          </div>
        </div>
      </div>
    </PortraitViewWrapper>
  </>
)

const PlaysMobileTabHeading = ({ playData }) => (
  <TabHeading className="">
    <div className="flex flex-col pl-4">
      <div> {playData?.title} - PLAY</div>
      <div>
        {isMobile && !isTablet ? (
          <div>
            {supportedPlayIds.includes(playData.id) ? playData.name : playData?.description}
          </div>
        ) : (
          <div>
            {supportedPlayIds.includes(playData.id) ? playData.name : playData?.description}
          </div>
        )}
      </div>
    </div>

    <img
      src={CrossIcon}
      alt="cross-icon"
      className="lg:invisible xs:mr-10"
      onClick={() => navigateTo(ROLES.BUSINESS_OWNER, 'dashboard')}
    />
  </TabHeading>
)

const PlaysWebHeading = ({ playData }) => {
  const { title, description } = playData

  useEffect(() => {
    scrollToTop()
  }, [])

  return title && description ? (
    <div>
      <div className="flex flex-col py-4">
        <div>
          {supportedPlayIds.includes(playData.id)
            ? `${playData.category} ${playData.level}`
            : title}
          &gt; Play &gt;
          <strong> {supportedPlayIds.includes(playData.id) ? playData.name : description}</strong>
        </div>
      </div>
    </div>
  ) : null
}

export default Plays

const LandscapeViewWrapper = styled.div`
  @media (orientation: landscape) {
    display: none;
  }
`

const PortraitViewWrapper = styled.div`
  @media (orientation: portrait) {
    display: none;
  }
`
